<template>
  <Login>
    <template #fallback="{ login, register, loginURI }">
      <slot
        name="fallback"
        :login="login"
        :register="register"
        :loginURI="loginURI"
      />
    </template>
    <template #default>
      <slot
        v-if="listing"
        name="default"
        :listing="listing"
        :bids="bids"
        :onCancelBid="cancel.requestCancel"
        :cancelling="cancel.cancelling.value"
        :cancelError="cancel.cancelError.value"
        :reload="loadBids"
      />
      <slot v-else name="loading">
        <p>Loading</p>
      </slot>
      <slot
        v-if="listing && listing.isLowBid()"
        name="cancel-dialog"
        :confirmCancel="cancel.confirmCancel"
        :dismissCancel="cancel.dismissCancel"
        :bid="cancel.pendingBid.value"
        :listing="listing"
        :cancelling="cancel.cancelling.value"
      >
        <cancel-bid-dialog
          id="cancel-dialog"
          :bid="cancel.pendingBid.value"
          :listing="listing"
          :cancelling="cancel.cancelling.value"
          @confirm="cancel.confirmCancel"
          @dismiss="cancel.dismissCancel"
        />
      </slot>
    </template>
  </Login>
</template>
<script lang="ts" setup>
import { useAuth } from "@/pkg/auth";
import { useListingStore } from "@/stores/listing";
import { Listing, ListingBid } from "@/types";
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useCancelBid } from "@/composables/useCancelBid";
import CancelBidDialog from "@/components/Listing/CancelBidDialog.vue";
import { EventHandler } from "@/util/event-bus";

const props = defineProps<{
  listingSlug: string;
  bidId?: string;
}>();

const listingStore = useListingStore();
const auth = useAuth();

const listing = ref<Listing | null>(null);
const bids = computed<ListingBid[]>(() => listing.value?.allBids() ?? []);
let authHandler: EventHandler | null = null;

const cancel = useCancelBid(() => props.listingSlug, {
  dialogId: "cancel-dialog",
  onCancelled: loadBids,
});

onMounted(() => {
  authHandler = auth.events.onAuth(loadBids);
});

onBeforeUnmount(() => {
  authHandler?.off(auth.events.bus);
  authHandler = null;
});

async function loadBids() {
  try {
    let response = await listingStore.getBids(props.listingSlug);
    listing.value = response;
  } catch (e) {
    console.error(e);
  }
}
</script>
